export const ELIGIBILITY_CHECKER_QUERY_KEY = 'plSk_3JJ_c1';
